<template>
  <div id="left_nav">
    <ul class="left_nav_list">
      <li class="no_arrow">
        <div
          class="left_f_list no_arrow"
          :class="{ active: $route.name === 'dashboard' }"
        >
          <router-link to="/">
            <span class="left_img">
              <img src="@/assets/media/images/left-icon/left-ic-1.png" alt="" />
            </span>
            <span>Dashboard</span>
          </router-link>
        </div>
      </li>
      <li v-if="can('ticket-manage')" class="no_arrow">
        <div
          class="left_f_list no_arrow"
          :class="{ active: $route.name === 'tickets' }"
        >
          <router-link :to="{ name: 'tickets' }">
            <span class="left_img">
              <img src="@/assets/media/images/left-icon/ticket.png" alt="" />
            </span>
            <span>Tickets</span>
          </router-link>
        </div>
      </li>
      <li class="no_arrow">
        <div
          class="left_f_list no_arrow"
          :class="{ active: $route.name === 'chat' }"
        >
          <router-link :to="{ name: 'chat' }">
            <span class="left_img">
              <img src="@/assets/media/images/left-icon/left-ic-6.png" alt="" />
            </span>
            <span>Chat</span>
          </router-link>
        </div>
      </li>

      <li
        v-if="
          can('company-manage') ||
          can('contact-manage') ||
          can('chat-setting-manage') ||
          can('support-request-manage')
        "
        @mouseleave="handleMouseLeave"
      >
        <div
          @mouseenter="handleMouseEnter"
          @click="
            navSwitch(
              $event,
              '.left_nav_list > li',
              '.left_f_list',
              '.left_nav_level2',
              '.left_f_list_level2'
            )
          "
          data-toggle="accordion"
          data-target="#Ticket"
          class="left_f_list"
          :class="{ open: ticketMenu.includes($route.name) && !isMenuCollapse }"
        >
          <span class="left_img">
            <span class="left_img"
              ><img src="@/assets/media/images/left-icon/left-ic-7.png" alt=""
            /></span>
          </span>
          <span>Settings</span>
        </div>
        <ul
          class="sub_accordion first_level"
          :class="{
            'open current':
              ticketSettingsMenu.includes($route.name) && !isMenuCollapse,
          }"
          id="Ticket"
        >
          <li
            v-if="can('company-manage')"
            :class="{ active_sub_menu: $route.name === 'companies' }"
          >
            <router-link :to="{ name: 'companies' }">Companies</router-link>
          </li>
          <li
            v-if="can('contact-manage')"
            :class="{ active_sub_menu: $route.name === 'contacts' }"
          >
            <router-link :to="{ name: 'contacts' }">Contacts</router-link>
          </li>
          <li
            v-if="can('chat-setting-manage')"
            :class="{ active_sub_menu: $route.name === 'chat_categories' }"
          >
            <router-link :to="{ name: 'chat_categories' }"
              >Chat Categories</router-link
            >
          </li>
          <li
            v-if="can('chat-setting-manage')"
            :class="{ active_sub_menu: $route.name === 'chat_settings' }"
          >
            <router-link :to="{ name: 'chat_settings' }"
              >Chat Settings</router-link
            >
          </li>
          <li
            v-if="can('support-request-manage')"
            :class="{
              active_sub_menu: $route.name === 'support_request_types',
            }"
          >
            <router-link :to="{ name: 'support_request_types' }"
              >Request Types</router-link
            >
          </li>
        </ul>
      </li>
      <li
        v-if="
          can('inventory-type-manage') ||
          can('inventory-brand-manage') ||
          can('inventory-name-manage') ||
          can('inventory-location-manage') ||
          can('ssl-manage') ||
          can('wowza-license-manage') ||
          can('domain-manage') ||
          can('inventory-manage')
        "
        @mouseleave="handleMouseLeave"
      >
        <div
          @mouseenter="handleMouseEnter"
          @click="
            navSwitch(
              $event,
              '.left_nav_list > li',
              '.left_f_list',
              '.left_nav_level2',
              '.left_f_list_level2'
            )
          "
          data-toggle="accordion"
          data-target="#Inventory"
          class="left_f_list"
          :class="{
            open: inventoryMenu.includes($route.name) && !isMenuCollapse,
          }"
        >
          <span class="left_img">
            <span class="left_img"
              ><img src="@/assets/media/images/left-icon/ticket.png" alt=""
            /></span>
          </span>
          <span>Inventory</span>
        </div>
        <ul
          class="sub_accordion first_level"
          :class="{
            'open current':
              inventoryMenu.includes($route.name) && !isMenuCollapse,
          }"
          id="Inventory"
        >
          <li
            v-if="can('inventory-manage')"
            :class="{
              active_sub_menu: [
                'inventories',
                'create-inventory',
                'update-inventory',
              ].includes($route.name),
            }"
          >
            <router-link :to="{ name: 'inventories' }">Inventories</router-link>
          </li>
          <li
            v-if="can('domain-manage')"
            :class="{
              active_sub_menu: [
                'domains',
                'create-domain',
                'update-domain',
              ].includes($route.name),
            }"
          >
            <router-link :to="{ name: 'domains' }">Domains</router-link>
          </li>
          <li
            v-if="can('license-manage')"
            :class="{
              active_sub_menu: [
                'licenses',
                'create-license',
                'update-license',
              ].includes($route.name),
            }"
          >
            <router-link :to="{ name: 'licenses' }">Licenses</router-link>
          </li>
          <li
            v-if="can('ssl-manage')"
            :class="{
              active_sub_menu: ['ssls', 'create-ssl', 'update-ssl'].includes(
                $route.name
              ),
            }"
          >
            <router-link :to="{ name: 'ssls' }">Ssls</router-link>
          </li>
          <li
            v-if="can('wowza-license-manage')"
            :class="{
              active_sub_menu: [
                'wowza-licenses',
                'create-wowza-license',
                'update-wowza-license',
              ].includes($route.name),
            }"
          >
            <router-link :to="{ name: 'wowza-licenses' }"
              >Wowza license</router-link
            >
          </li>

          <li
            v-if="can('inventory-type-manage')"
            :class="{
              active_sub_menu: [
                'types',
                'create-types',
                'update-types',
              ].includes($route.name),
            }"
          >
            <router-link :to="{ name: 'types' }">Types</router-link>
          </li>

          <li
            v-if="can('inventory-brand-manage')"
            :class="{
              active_sub_menu: [
                'brands',
                'create-brands',
                'update-brands',
              ].includes($route.name),
            }"
          >
            <router-link :to="{ name: 'brands' }">Brands</router-link>
          </li>
          <li
            v-if="can('inventory-name-manage')"
            :class="{
              active_sub_menu: [
                'names',
                'create-names',
                'update-names',
              ].includes($route.name),
            }"
          >
            <router-link :to="{ name: 'names' }">Names</router-link>
          </li>
          <li
            v-if="can('inventory-location-manage')"
            :class="{
              active_sub_menu: [
                'locations',
                'create-locations',
                'update-locations',
              ].includes($route.name),
            }"
          >
            <router-link :to="{ name: 'locations' }">Locations</router-link>
          </li>
        </ul>
      </li>
      <li @mouseleave="handleMouseLeave">
        <div
          @mouseenter="handleMouseEnter"
          @click="
            navSwitch(
              $event,
              '.left_nav_list > li',
              '.left_f_list',
              '.left_nav_level2',
              '.left_f_list_level2'
            )
          "
          data-toggle="accordion"
          data-target="#HR"
          class="left_f_list"
          :class="{ open: ticketMenu.includes($route.name) && !isMenuCollapse }"
        >
          <span class="left_img">
            <span class="left_img"
              ><img src="@/assets/media/images/left-icon/left-ic-7.png" alt=""
            /></span>
          </span>
          <span>HR</span>
        </div>
        <ul
          class="sub_accordion first_level"
          :class="{
            'open current': hrMenu.includes($route.name) && !isMenuCollapse,
          }"
          id="HR"
        >
          <template v-if="user && user.user_role === 'Admin'">
            <li
              v-if="can('agent-manage')"
              :class="{ active_sub_menu: $route.name === 'users' }"
            >
              <router-link :to="{ name: 'users' }">Employees</router-link>
            </li>
            <li :class="{ active_sub_menu: $route.name === 'shifts-calendar' }">
              <router-link :to="{ name: 'shifts-calendar' }"
                >Working shifts</router-link
              >
            </li>
            <li :class="{ active_sub_menu: $route.name === 'leaves-calender' }">
              <router-link :to="{ name: 'leaves-calender' }"
                >Leave requests</router-link
              >
            </li>
            <li
              :class="{ active_sub_menu: $route.name === 'schedules-calender' }"
            >
              <router-link :to="{ name: 'schedules-calender' }"
                >Work schedules</router-link
              >
            </li>

            <li
              v-if="can('roles-manage')"
              :class="{ active_sub_menu: $route.name === 'roles' }"
            >
              <router-link :to="{ name: 'roles' }">Roles</router-link>
            </li>
            <li
              v-if="can('group-manage')"
              :class="{ active_sub_menu: $route.name === 'groups' }"
            >
              <router-link :to="{ name: 'groups' }">Groups</router-link>
            </li>
            <li
              v-if="can('shift-manage')"
              :class="{ active_sub_menu: $route.name === 'shifts' }"
            >
              <router-link :to="{ name: 'shifts' }">Shifts</router-link>
            </li>
          </template>
          <template v-else>
            <li
              :class="{
                active_sub_menu: $route.name === 'working-shifts-calendar',
              }"
            >
              <router-link :to="{ name: 'working-shifts-calendar' }"
                >Working shifts</router-link
              >
            </li>
            <li :class="{ active_sub_menu: $route.name === 'leave-requests' }">
              <router-link :to="{ name: 'leave-requests' }"
                >Leave requests</router-link
              >
            </li>
            <li
              :class="{ active_sub_menu: $route.name === 'working-schedules' }"
            >
              <router-link :to="{ name: 'working-schedules' }"
                >Work schedules</router-link
              >
            </li>
          </template>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
import { TOKEN } from '@/util/AppAbility';
import { useAbility } from '@casl/vue';
import { mapGetters } from 'vuex';
import helperMixins from '@/mixins/helperMixins';

export default {
  mixins: [helperMixins],
  inject: {
    ability: { from: TOKEN },
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE,
      ticketMenu: [
        'tickets',
        'create-ticket',
        'update-ticket',
        'view-ticket',
        'create-email',
        'support-requests',
        'create-support-request',
        'chat',
        'update-support-request',
        'view-support-request',
        'users',
        'create-user',
        'update-user',
        'companies',
        'create-company',
        'update-company',
        'view-company',
        'contacts',
        'create-contact',
        'update-contact',
        'view-contact',
        'chat_categories',
        'chat_settings',
        'groups',
        'create-group',
        'update-group',
        'view-group',
        'support_request_types',
        'create_support_request_type',
        'update_support_request_type',
        'view_support_request_type',
        'roles',
      ],
      ticketSettingsMenu: [
        'create-email',
        'support-requests',
        'create-support-request',
        'update-support-request',
        'view-support-request',
        'companies',
        'create-company',
        'update-company',
        'view-company',
        'contacts',
        'create-contact',
        'update-contact',
        'view-contact',
        'support_request_types',
        'create_support_request_type',
        'update_support_request_type',
        'view_support_request_type',
      ],
      inventoryMenu: [
        'inventories',
        'create-inventory',
        'update-inventory',
        'domains',
        'create-domain',
        'update-domain',
        'licenses',
        'create-license',
        'update-license',
        'ssls',
        'create-ssl',
        'update-ssl',
        'wowza-licenses',
        'create-wowza-license',
        'update-wowza-license',
        'types',
        'create-types',
        'update-types',
        'brands',
        'create-brands',
        'update-brands',
        'names',
        'create-names',
        'update-names',
        'locations',
        'create-locations',
        'update-locations',
      ],
      hrMenu: [
        'users',
        'create-user',
        'update-user',
        'leave-requests',
        'create-leave-request',
        'update-leave-request',
        'leaves-all',
        'leaves-calender',
        'create-leave',
        'update-leave',
        'working-schedules',
        'create-working-schedule',
        'update-working-schedule',
        'schedules-all',
        'schedules-calender',
        'create-schedule',
        'update-schedule',
        'roles',
        'groups',
        'create-group',
        'update-group',
        'view-group',
        'shifts',
        'create-shift',
        'update-shift',
      ],
    };
  },
  setup() {
    const { can } = useAbility();

    return {
      can,
    };
  },
  computed: {
    ...mapGetters({
      user: 'auth/getUser',
      isMenuCollapse: 'settings/isMenuCollapse',
    }),
  },
  mounted() {},
  methods: {
    handleMouseEnter() {
      if (window.$('.left_menu_collapse').length > 0) {
        this.showHideNav(
          event,
          '.left_nav_list > li',
          '[data-toggle="accordion"]',
          '.left_f_list'
        );
      }
    },
    handleMouseLeave() {
      if (window.$('.left_menu_collapse').length > 0) {
        this.hideOtherNav('.left_nav_list > li', '.left_f_list');
        this.hideOtherNav('.left_nav_level2', '.left_f_list_level2');
        this.hideOtherNav('.left_nav_level3', '.left_f_list_level3');
      }
    },
    reload(name) {
      if (this.$route.name === name) {
        this.$store.commit('setReload', true);
      }
    },
  },
};
</script>
<style scoped>
.active_sub_menu {
  color: #000000;
  font-weight: 600;
}

.router-link-exact-active {
  color: #000000;
  font-weight: 600;
}

.d_block {
  display: block;
}

.left_nav_level2 .active {
  background: rgba(113, 113, 113, 0.3);
}

.active__sub_sub_menu a {
  color: #000000;
  font-weight: 600;
}
</style>
